import { _ as o } from "./_copyObject.js";
import { k as r } from "./keysIn.js";
var c = o, e = r;
function n(t) {
  return c(t, e(t));
}
var p = n;
export {
  p as t
};
//# sourceMappingURL=toPlainObject.js.map
